import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {ViewController} from "ionic-angular/index";
import {WordProvider} from "../../providers/word/word";
import {ExceptionOption} from "../scroll-list/scroll-list";

/**
 * Generated class for the WordRecordComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'word-record',
  templateUrl: 'word-record.html'
})
export class WordRecordComponent implements OnChanges{

  @Input() username;
  @Input() chatroomname;
  @Input() keyword;
  @Input() scope;

  constructor(public viewCtrl:ViewController,public wordService:WordProvider) {
    console.log('Hello WordRecordComponent Component');
  }

  ngOnChanges(changes:SimpleChanges){
    if(this.username && this.keyword){
      this.getRecord();
    }
  }

  expOpt: ExceptionOption = {
    errBtnText:'重新加载',
    errText:'加载失败，请重试！'
  };

  is_loading_recode;
  is_error_recode;
  recode_list;
  total_count;
  page = 1;
  pagesize = 10;
  getRecord(){
    this.is_loading_recode = true;
    this.is_error_recode = false;
    this.wordService.getWordRecord(this.chatroomname,this.scope,this.keyword,this.page,this.pagesize).subscribe(res => {
        this.is_loading_recode = false;
        this.is_error_recode = false;
        //TODO:main function
        this.recode_list = (this.recode_list || []).concat(res['content']['record_data']);
        this.total_count = res['content']['total_count'];
      },
      err => {
        this.is_loading_recode = false;
        this.is_error_recode = true;
      })
  }

  onPageNext(e){
    this.page ++ ;
    this.getRecord();
  }
}



// WEBPACK FOOTER //
// ./src/components/word-record/word-record.ts